// extracted by mini-css-extract-plugin
export var locationCard = "_h5-0";